import React, {useState} from "react";
import i18n from "../../i18n";
import {withStyles} from "@material-ui/core/styles";
import Toolbar from "../../components/Toolbar/Toolbar";
import Layout from "../../components/Layout/Layout";
import Paper from "@material-ui/core/Paper";
import Table from "@material-ui/core/Table";
import TableHead from "@material-ui/core/TableHead";
import TableBody from "@material-ui/core/TableBody";
import TableRow from "@material-ui/core/TableRow";
import TableCell from "@material-ui/core/TableCell";
import Icon from "@material-ui/core/Icon";
import CsrfField from "../../components/Form/CsrfField";
import Typography from "@material-ui/core/Typography";
import EllipsisWithTooltip from "../../components/Formater/EllipsisWithTooltip";
import TowLine from "../../components/Text/TwoLine";
import swal from "sweetalert";
import {swalCancelDelete} from "../../components/Form/utils";
import IconButton from "@material-ui/core/IconButton";
import TableRowClickable from "../../components/Form/TableRowClickable";
import moment from "moment";
import TablePagination from "@material-ui/core/TablePagination";

const deleteNotification = (e, notification) => {
    e.preventDefault();
    swal({
        title: i18n.get('notification.remove'),
        dangerMode: true,
        icon: "warning",
        ...swalCancelDelete(),
    }).then((confirmed) => {
        if (confirmed) {
            document.getElementById(`delete-${notification.id}`).submit();
        }
    });
};

const NotificationIndex = ({classes, notifications}) => {

    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(25);

    const handleChangePage = (event, newPage) => {
        setPage(newPage);
    };

    const handleChangeRowsPerPage = (event) => {
        setRowsPerPage(+event.target.value);
        setPage(0);
    };

    return (
        <Layout>
            <Toolbar
                disableGutters
                title={i18n.get('notification.self_plural')}
                subtitle={''}
            />

            <Paper className={classes.paper}>
                {notifications && notifications.length > 0 ? (
                    <React.Fragment>
                        <Table className={classes.list}>
                            <TableHead>
                                <TableRow>
                                    <TableCell> </TableCell>
                                    <TableCell align={'center'}>{ i18n.get('notification.date') }</TableCell>
                                    <TableCell align={'center'}>{ i18n.get('notification.number') }</TableCell>
                                    <TableCell>{ i18n.get('notification.title') }</TableCell>
                                    <TableCell>{ i18n.get('notification.content') }</TableCell>
                                    <TableCell align={'center'}>{ i18n.get('notification.actions') }</TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {notifications.map(notification =>
                                    <TableRowClickable action={`/notifications/${notification.id}`} key={`notification_${notification.id}`}>
                                        {/* action={notification.data.showroute} */}
                                        <TableCell style={{width:24}}>
                                            {notification.read_at
                                                ? <Icon style={{fontSize:18}} style={{opacity:0.5}}>playlist_add_check</Icon>
                                                : <Icon style={{fontSize:18}} color={'primary'}>priority_high</Icon>
                                            }
                                        </TableCell>
                                        <TableCell align={'center'} style={{width:90}}>
                                            <Typography component={'h6'}>
                                                {notification.created_at && moment(notification.created_at).format('DD.MM.YYYY') }
                                            </Typography>
                                        </TableCell>
                                        <TableCell align={'center'} style={{width:90}}>
                                            <Typography component={'h6'}>
                                                {notification.data.number}
                                            </Typography>
                                        </TableCell>
                                        <TableCell style={{width:'25%'}}>
                                            <Typography component={'h6'}>
                                                <EllipsisWithTooltip>
                                                    {notification.data.title}
                                                </EllipsisWithTooltip>
                                            </Typography>
                                            <TowLine
                                                sub={notification.data.subtitle}
                                            />
                                        </TableCell>
                                        <TableCell>
                                            <Typography component={'h6'}>
                                                <EllipsisWithTooltip>
                                                    {notification.data.content}
                                                </EllipsisWithTooltip>
                                            </Typography>
                                        </TableCell>
                                        <TableCell align={'center'} onClick={ e => { e.stopPropagation('all'); } } style={{cursor:'default',width:100}}>
                                            <form
                                                id={`delete-${notification.id}`}
                                                action={`/notifications/${notification.id}`}
                                                className={classes.deleteForm}
                                                method="POST"
                                            >
                                                <input type="hidden" name="_method" value="delete"/>
                                                <CsrfField/>
                                            </form>
                                            <IconButton
                                                component="a"
                                                onClick={(e) => deleteNotification(e, notification)}
                                            ><Icon>delete</Icon></IconButton>
                                        </TableCell>
                                    </TableRowClickable>
                                )}
                            </TableBody>
                        </Table>
                        {notifications.length > rowsPerPage && (
                            <TablePagination
                                rowsPerPageOptions={[rowsPerPage,rowsPerPage*2,rowsPerPage*4]}
                                labelRowsPerPage={i18n.get('deficiency.rows_per_page')}
                                labelDisplayedRows={
                                    ({ from, to, count }) =>
                                        i18n.get('deficiency.displayed_rows',{
                                            from: from + '' ,
                                            to: to + '',
                                            count: count + ''
                                        })
                                }
                                nextIconButtonProps={{size:'small'}}
                                backIconButtonProps={{size:'small'}}
                                component="div"
                                count={notifications.length}
                                rowsPerPage={rowsPerPage}
                                page={page}
                                onChangePage={handleChangePage}
                                onChangeRowsPerPage={handleChangeRowsPerPage}
                            />
                        )}
                    </React.Fragment>
                ) : (
                    <Typography component={'h6'}>
                        {i18n.get('notification.self_no')}
                    </Typography>
                )}
            </Paper>
        </Layout>
    );
}




const styles = theme => ({
    span: {
        display: 'inline',
        margin: '0 5px',
    },
    paper: {
        marginTop: theme.spacing.unit * 3,
        marginBottom: theme.spacing.unit * 3,
        padding: theme.spacing.unit * 2,
        [theme.breakpoints.up(600 + theme.spacing.unit * 3 * 2)]: {
            marginTop: theme.spacing.unit * 6,
            marginBottom: theme.spacing.unit * 6,
            padding: theme.spacing.unit * 3,
        },
    },
    list: {
        "& tr": {
            height:40,
        },
        "& td" : {
            paddingTop:0,
            paddingBottom:0,
        },
        "& a": {
            padding:2,
        }
    },
});

export default withStyles(styles)(NotificationIndex);
